// src/services/api.js
import axios from 'axios';

export const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// Los GIF de ejercicios los sirve el backend desde Backend/videos/, fuera de /api
export const ORIGEN_API = API_URL.replace(/\/api\/?$/, "");

const API = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

// Interceptor para añadir el token JWT automáticamente a cada request
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// FUNCIONES PERSONALIZADAS PARA EL CHAT (puedes agregar más)
export const getMessages = async (chatId) => {
  const res = await API.get(`/messages/${chatId}`);
  return res.data;
};

export const sendMessage = async (chatId, content) => {
  const res = await API.post(`/messages`, { chatId, content });
  return res.data;
};

// Puedes agregar funciones para foods, exercises, users, etc. así:
// export const getFoods = async () => API.get("/foods");

export default API;
